import React from 'react';
import { Section, SectionTitle } from '../../../components/TwoColumnLayout';
import { Link } from 'react-router-dom';
import { Icon } from '../../../components/Icon';
import styled from 'styled-components';

interface Props {
	accountType: string;
}

const Wrapper = styled.div`
  width: 18em;
  margin: auto;
  text-align: center;
  .button-container{
     button {
      margin: auto;
      width: 10em;
      height: 2em;
      border: 2px solid red;
      border-radius: 8px;
      background-color: white;
      padding: 0.4em;
      font-weight: 600;
      color: red;
    }
    margin-bottom: 2.614em;
  }
`;

const Container = styled.div`
  min-height:120px;

  padding-top: 1rem;
    input {
    width: 250px;
  }

  input[type="text"] {
    min-width: 450px;
  }

  .info{
    width: 200px;
    font-size: 1rem;
    padding-left: 1rem;
  }

  .grayInfo{
    font-size: 1rem;
    color: darkgray;
  }
`;

const LeftAlign = styled.div`
  float:left;
  //border: 1px solid red;
`;

const RightAlign = styled.div`
  //border: 1px solid green;
  padding-top: 1rem;
  overflow: hidden; /* if you don't want #second to wrap below #first */

  .info{
    float: right;
    color: red;
  }
`;

const Header = styled.div`
  font-size: 1.6em;
  text-align: center;
  margin-bottom: 1em;
`;

export const PasswordInfo: React.FC<Props> = (props: Props) => {
	return (
		<div>
			{props.accountType === 'consumer' && (
				<Wrapper>
					<Header>Salasana</Header>
					<div className={'button-container'}>
						<Link to="/account/changePassword">
							<button>Vaihda salasana</button>
						</Link>
					</div>
				</Wrapper>
			)}
			{props.accountType !== 'consumer' && (
				<div>
					<SectionTitle>Salasana</SectionTitle>
					<Section>
						<Container>
							<LeftAlign>
								<div className="info">
									<p>Salasana</p>
									<p>********</p>
								</div>
							</LeftAlign>
							<RightAlign>
								<div className="info">
									<Link to="/account/changePassword" className={"edit-link-btn"}>
										<Icon name="small--edit" />
										<p>Vaihda salasana</p>
									</Link>
								</div>
							</RightAlign>
						</Container>
					</Section>
				</div>
			)}
		</div>
	);
};
